module.exports = __webpack_public_path__ + "img/doc_5.a819eb6b.png";